/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { LogoMultiCardsSectionFragment } from "@cosmos/hygraph-schema";

import {
	CosmosButton,
	ResponsiveContainer,
	SectionContainer,
	TextLink,
	BackgroundContainer,
	TitleDescStack,
} from "@components/elements";
import { css, cx } from "@panda/css";
import { HStack, VStack } from "@panda/jsx";
import { flex } from "@panda/patterns";
import { SystemStyleObject } from "@panda/types";

import { LogoMultiCards } from "./LogoMultiCards.molecule";
import { useMemo } from "react";

const styles: SystemStyleObject = {
	flexBasis: "full",
	"& .cosmos-rich-text.heading": {
		smDown: {
			textStyle: "headingLG",
		},
	},
};

export const LogoMultiCardsSection = ({
	title,
	desc,
	buttons,
	links,
	cards,
	config,
}: LogoMultiCardsSectionFragment): React.JSX.Element => {
	const descriptionColor = useMemo(
		() => (config?.backgroundImage ? "eds.text.primary" : undefined),
		[config?.backgroundImage],
	);

	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<div
						className={cx(
							"logo-multi-card-section",
							flex({
								flexDir: "row",
								alignItems: "center",
								justifyContent: "space-between",
								columnGap: "eds.dimension.40",
								xxlDown: {
									justifyContent: "flex-start",
									columnGap: "eds.dimension.32",
								},
								lgDown: {
									flexDir: "column",
									rowGap: "eds.dimension.32",
									alignItems: "start",
								},
							}),
						)}
					>
						<VStack alignItems="flex-start" gap="eds.dimension.24" className={css(styles)} maxWidth="1175px">
							<TitleDescStack
								title={{ ...title, variant: "headingXL", as: "h4" }}
								description={{ html: desc, color: descriptionColor }}
								className={css({ maxWidth: "840px" })}
							/>
							{buttons?.length ? (
								<HStack gap="eds.dimension.24">
									{(buttons || []).map((btn, i) => (
										<CosmosButton key={`btn-${i}`} {...btn} size="lg" />
									))}
									{(links || []).map((link, i) => {
										if (!link.href || !link.label) return null;

										return <TextLink key={`link-${i}`} {...link} href={link.href} />;
									})}
								</HStack>
							) : null}
						</VStack>
						<LogoMultiCards cards={cards || []} descriptionColor={descriptionColor} />
					</div>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
